import React from 'react';
import PropTypes from 'prop-types';
import { NewsStream } from 'ThreeTerminal_mobile_dynamic';
import { allLookData } from '../../../../../services/api';
import { h5PageCount } from 'ThreeTerminal_utils';
import styles from './index.css';
import { callApp } from '@ifeng-fe/callapp';
import errorBoundary from '@ifeng-fe/errorBoundary';

class ShareSucc extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        change: PropTypes.func,
        isVideoShare: PropTypes.bool,
    };

    state = {
        shareFeedDataArr: [],
    };

    componentDidMount() {
        const { content } = this.props;

        h5PageCount([
            {
                behavior: 'action',
                type: 'secshare',
                other: {
                    ref: content.base62Id ? `ucms_${content.base62Id}` : content.guid,
                    kind: 'video',
                },
            },
        ]);
        this.loadFeedData();
    }

    async loadFeedData() {
        const { content } = this.props;

        const config = {
            aid: content.base62Id ? `ucms_${content.base62Id}` : content.guid,
            title: content.title,
            url: location.href,
        };

        try {
            const data = await allLookData(config, 'video');

            if (!data) return false;
            this.formalData(data);
        } catch (e) {
            console.error(e);
        }
    }

    formalData(data) {
        const { content } = this.props;
        const shareArr = [];

        data.forEach((item, index) => {
            const itemObj = {};

            itemObj.id = item.documentId || item.commentsUrl || item.adId;
            itemObj.title = item.title || '';
            itemObj.url = (item.link && item.link.weburl) || '';
            // itemObj.source = item.source || '';
            itemObj.commentUrl = item.commentsUrl || '';
            itemObj.type = item.type;
            itemObj.thumbnails = {};
            itemObj.thumbnails.image = [];
            itemObj.callUp = 1;
            itemObj.newstype = itemObj.type;
            itemObj.thumbnails.image.push({
                bytes: 277,
                width: '340',
                url: item.thumbnail || '',
                height: '188',
            });
            itemObj.clickCount = {
                behavior: 'action',
                type: 'click',
                other: {
                    to: item.documentId || item.commentsUrl,
                    ref: content.base62Id ? `ucms_${content.base62Id}` : content.guid,
                    rnum: index,
                    tag: 't5',
                    kind: item.type,
                    url: item.link && encodeURIComponent(item.link.weburl),
                },
            };

            shareArr.push(itemObj);
        });

        this.setState({
            shareFeedDataArr: [...this.state.shareFeedDataArr, ...shareArr.slice(0, 3)],
        });
    }

    // getDerivedStateFromProps(props, state) {
    //     if (props.isShowFixed !== state.isShowFixed) {
    //         this.setState({
    //             isShowFixed: props.isShowFixed,
    //         });
    //     }

    //     return null;
    // }

    handleClick = (url, id, newstype) => {
        const { content, isVideoShare } = this.props;
        const doc_type = newstype;
        const aid = id;
        const client = isVideoShare ? 'videoApp' : 'newsApp';

        h5PageCount([
            {
                behavior: 'action',
                type: 'readmore',
                other: {
                    ref: content.base62Id ? `ucms_${content.base62Id}` : content.guid,
                    kind: 'article',
                },
            },
        ]);

        callApp({
            client,
            docType: doc_type,
            pid: aid,
        });
    };

    closeShareSucc = () => {
        this.props.change();
    };

    render() {
        /**
         * 组件分发数据
         */
        const { content } = this.props;
        const { shareFeedDataArr } = this.state;
        const artType = content.type === 'article' ? 'doc' : content.type;

        return (
            <React.Fragment>
                {shareFeedDataArr.length > 0 && (
                    <section className={styles.shareSucc}>
                        <div className={styles.shareSuccBox}>
                            <div className={styles.md_th}>
                                <span className={styles.title}>分享成功</span>
                                <a
                                    href="javascript:;"
                                    onClick={this.closeShareSucc.bind(this)}
                                    className={styles.close}
                                />
                            </div>
                            <NewsStream content={shareFeedDataArr} isDisplayLoadingMore={false} />
                            <a
                                href="javascript:;"
                                onClick={this.handleClick.bind(this, location.href, content.guid, artType)}
                                className={styles.lookMore}>
                                查看更多
                            </a>
                        </div>
                    </section>
                )}
            </React.Fragment>
        );
    }
}

export default errorBoundary(ShareSucc);
